import { Modal } from "@mui/material";
import styled from "styled-components";

export default function GenericModal({
    open,
    onClose,
    title,
    subtitle,
    children,
    width = 900,
    showClose = true,
    onCloseClick,
}) {
    if (!open) return null;

    const handleClose = () => {
        if (onCloseClick) onCloseClick();
        if (onClose) onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="generic-modal-title"
            aria-describedby="generic-modal-subtitle"
        >
            <ModalContainer width={width}>
                {showClose && (
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleClose}
                        alt="Fechar"
                        data-testid="close-modal"
                    />
                )}

                <>
                    <ModalTitle id="generic-modal-title">{title}</ModalTitle>
                    <ModalTitleLine />
                </>
                {subtitle && (
                    <ModalSubtitle id="generic-modal-subtitle">
                        {subtitle}
                    </ModalSubtitle>
                )}
                {children}
            </ModalContainer>
        </Modal>
    );
}

const ModalTitleLine = styled.div`
    width: 96px;
    height: 2px;
    background: #57c4c2;
    margin-bottom: 8px;
`;

const ModalContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 900px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    padding: 32px 40px 24px 40px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`;

const ModalTitle = styled.h2`
    color: var(--Secundary-Pure, #181122);
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 4px;
    text-align: left;
`;

const ModalSubtitle = styled.p`
    color: var(--Dark-Pure, #000);
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 16px;
    text-align: left;
    margin-top: 15px;
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;
